<template>
  <v-card outlined height="100%">
    <v-card-title>
      <v-row class="no-gutters justify-space-between">
        <v-col class="col-auto">
          {{ $t('shopBackendBookingDetail.buyer') }}
        </v-col>
        <v-col class="col-auto text-right">
          <v-btn outlined color="primary" @click="$refs.editProfile.show()">
            <span class="fal fa-pen mr-2" />
            {{ $t('bookingDetail.editBuyer') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text v-if="buyer">
      <p>
        {{ buyer.getCompany() }}<br />
        {{ buyer.getFullName() }} <br />
        {{ buyer.getAddress() }} <br />
        {{ buyer.getZip() }} {{ buyer.getCity() }}
      </p>
      <p>
        {{ buyer.getPhone() }} <br />
        {{ buyer.getMail() }}
      </p>
    </v-card-text>
    <add-new-profile
      ref="editProfile"
      edit
      edit-other-users-profile
      hide-agb
      :show-card-list="false"
      :profile.sync="buyer"
      :additional-fields.sync="additionalFields"
      @refresh="(newBuyer) => $emit('update:buyer', newBuyer)"
    />
  </v-card>
</template>

<script>
import AddNewProfile from '@/components-shared/users/AddNewProfile'
export default {
  name: 'BookingBuyerInformation',
  components: { AddNewProfile },
  props: {
    buyer: {
      required: true,
      type: Object,
    },
  },
  computed: {
    additionalFields() {
      return {
        address: this.buyer.getAddress() || '',
        city: this.buyer.getCity() || '',
        zip: this.buyer.getZip() || '',
        country: this.buyer.getCountry() || '',
        mail: this.buyer.getMail() || '',
        company: this.buyer.getCompany() || '',
        phone: this.buyer.getPhone() || '',
      }
    },
  },
}
</script>
